import React from "react";
import { motion } from "framer-motion";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Modes from "@/components/site/Modes";
import ContactSection from "@/components/site/ContactSection";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[hsl(var(--bg))] text-[hsl(var(--text))]">
      <Nav />
      <Hero />
      <About />
      <TrustStrip />
      <Services />
      <Modes />
      <ContactSection />
      <Footer />
    </main>
  );
}
